import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useLocalStorageTradeId } from '@sorare/core/src/components/cardswap/useLocalStorageKey';
import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import {
  NBACompleteCardTradeMutation,
  NBACompleteCardTradeMutationVariables,
} from './__generated__/useCompleteTradeMutation.graphql';

const NBA_COMPLETE_CARD_TRADE_MUTATION = gql`
  mutation NBACompleteCardTradeMutation(
    $id: UUID!
    $userReceiveCardSampleId: UUID
  ) {
    completeNBACardTrade(
      id: $id
      userReceiveCardSampleId: $userReceiveCardSampleId
    ) {
      id
      isComplete
    }
  }
` as TypedDocumentNode<
  NBACompleteCardTradeMutation,
  NBACompleteCardTradeMutationVariables
>;

export const useCompleteTradeMutation = () => {
  const [completeTradeMutation] = useMutation(
    NBA_COMPLETE_CARD_TRADE_MUTATION,
    { warnIfNoErrorHandling: false }
  );
  const { get } = useLocalStorageTradeId(Sport.NBA);

  const submit = async (userReceiveCardSampleId: string | null) => {
    const tradeId = get();
    if (!tradeId) return;
    await completeTradeMutation({
      variables: {
        id: tradeId,
        userReceiveCardSampleId,
      },
    });
  };

  return submit;
};
